import {AfterViewInit, Component, HostListener, OnInit} from '@angular/core';
import {
  INavigationTab,
  NavigationService,
  StandaloneViewResolverService,
  ToolbarService,
  TranslateService,
  ViewControlService
} from 'bos-commons';
import {HtmlPageComponent} from './html-page/html-page.component';
import {HtmlAnchorComponent} from './html-anchor/html-anchor.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit, AfterViewInit {

  public show = false;

  constructor(private navigationService: NavigationService,
              private toolbarService: ToolbarService,
              private viewControlService: ViewControlService,
              private translateService: TranslateService,
              private standaloneViewResolverService: StandaloneViewResolverService) {
  }

  ngOnInit(): void {

    this.standaloneViewResolverService.addViewByKey("HtmlPage", HtmlPageComponent);
    this.standaloneViewResolverService.addViewByKey("HtmlAnchor", HtmlAnchorComponent);

    this.viewControlService.showProfileComponent.next(false);
    this.viewControlService.showTitleBar.next(true);
    this.viewControlService.showNavigation.next(true);
    this.viewControlService.showNavigation.next(true);
    this.viewControlService.popupMode.next(true)
    this.viewControlService.mobileVersion.subscribe(value => {
      this.viewControlService.showHamburger.next(value);
      this.viewControlService.showNavigation.next(!value);
    })
    this.viewControlService.showHamburger.next(true);
    this.viewControlService.windowWidth.next(window.innerWidth);
    this.viewControlService.showSearchForm.next(false);
  }

  ngAfterViewInit() {

    this.translateService.initializedBehaviourSubject.subscribe(value => {
      if (value) {
        this.navigationService.restNavigation.next(this.getNavigation());
        this.toolbarService.titleBar.next(this.translateService.translateWithArgs("auth.admin.title"))
        this.show = true;
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.viewControlService.windowWidth.next(window.innerWidth);
  }

  private getNavigation(): INavigationTab [] {
    return [{
      icon: '', navigationGroups: [
        {
          name: this.translateService.translateWithArgs('admin.menu'),
          items: [{
            id: 'admin.login',
            name: this.translateService.translateWithArgs('admin.login'),
            routerAction: {
              commands: ['boslogin'],
              extras: {}
            },
            matIcon: 'reply',
            active: false,
            expanded: true,
            allowCreate: false
          },
            {
              id: 'admin.footer',
              name: this.translateService.translateWithArgs('admin.footer'),
              routerAction: {
                commands: ['admin', 'footer'],
                extras: {}
              },
              matIcon: 'satellite',
              active: false,
              expanded: true,
              allowCreate: false
            },
            {
              id: 'admin.sessions',
              name: this.translateService.translateWithArgs('admin.sessions'),
              routerAction: {
                commands: ['admin', 'sessions'],
                extras: {}
              },
              matIcon: 'supervised_user_circle',
              active: false,
              expanded: true,
              allowCreate: false
            },
            {
              id: 'admin.links',
              name: this.translateService.translateWithArgs('admin.footer.links'),
              routerAction: {
                commands: ['admin', 'links'],
                extras: {}
              },
              matIcon: 'link',
              active: false,
              expanded: true,
              allowCreate: false
            },
            {
              id: 'admin.sessions.config',
              name: this.translateService.translateWithArgs('admin.sessions.config'),
              routerAction: {
                commands: ['admin', 'sessionconfig'],
                extras: {}
              },
              matIcon: 'av_timer',
              active: false,
              expanded: true,
              allowCreate: false
            },
            {
              id: 'admin.levenshtein.config',
              name: this.translateService.translateWithArgs('admin.levenshtein.config'),
              routerAction: {
                commands: ['admin', 'levenshteinconfig'],
                extras: {}
              },
              matIcon: 'lock_open',
              active: false,
              expanded: true,
              allowCreate: false
            },
            {
              id: 'admin.logout',
              name: this.translateService.translateWithArgs('admin.logout'),
              routerAction: {
                commands: ['boslogin', 'logout'],
                extras: {}
              },
              matIcon: 'exit_to_app',
              active: false,
              expanded: true,
              allowCreate: false
            }
          ]
        },
      ]
    },
    ];
  }
}
